import { FormattedMessage } from 'react-intl'

import { Button, type TDefaultButtonProps } from '@/src/elements/button/default'
import type { DONATION_SOURCE } from '@/src/features/donation/api/types/donation'
import { useDonationContext } from '@/src/features/donation/context/DonationContext'
import { ICON } from '@/src/general/enums/icons'

export const DonationButton = ({
  ref,
  donationSource,
  ...otherProps
}: TDefaultButtonProps & { donationSource: DONATION_SOURCE }) => {
  const { openDonationBanner } = useDonationContext()

  return (
    <Button
      ref={ref}
      onPress={() => openDonationBanner(donationSource)}
      colors="danger"
      startIcon={ICON.HEART}
      variant="faded"
      {...otherProps}
    >
      <FormattedMessage id="app.i-donate" />
    </Button>
  )
}
